import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  currentOrganizationSelector,
  organizationUsersSelector,
  userSelector,
} from "../../store/selectors";
import { ReactComponent as MicIcon } from "../../assets/mic.svg";
import { ReactComponent as StopRecordIcon } from "../../assets/StopRecordIcon.svg";
import UserSuggestionDropdown from "./UserSuggestionDropdown";
import TagsSuggestionDropdown from "../TagsSuggestionDropdown/TagsSuggestionDropdown";
import "./WriteComment.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
// Import icons (you'll need to provide these)
import locationIcon from "../../assets/location.svg";
import screenshotIcon from "../../assets/screenshot.svg";
import drawingIcon from "../../assets/drawing.svg";
import attachmentIcon from "../../assets/attachment.svg";
import {
  completeMediaUpload,
  createMediaPresign,
  createTag,
} from "../../store/projectsSlice";
import toast from "react-hot-toast";
import TagComponent from "../TagsSuggestionDropdown/TagComponent";
import Avatar from "../Avatar/Avatar";
import { OrbitProgress } from "react-loading-indicators";
import EmojiPicker from "emoji-picker-react";
import useIsMobile from "../../hooks/useIsMobile";
import VoiceRecorder from "./VoiceRecorder/VoiceRecorder";

const WriteComment = ({
  newCommentEnd = null,
  setNewCommentEnd = () => {},
  sharedOrgId,
  newMarkerInfo,
  setNewMarkerInfo,
  currentTime,
  versionId,
  onSubmit,
  videoRef,
  isSendingComment,
  videoControls,
  markerPoint: propMarkerPoint,
  onSetMarkerPoint,
  isLocationMode,
  setIsLocationMode,
  onSubmitComment,
  updateTagsArray,
  tagsArray,
  projectUsers,
  tagsDefaultColors,
  currentEditedComment,
  resetCurrentEditedComment,
  isShared,
  onShowSharedNeedLogin,
}) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const [timeRange, setTimeRange] = useState({
    start: currentTime || 0,
    end: null,
  });
  const user = useSelector(userSelector);
  const organizationUsers = useSelector(organizationUsersSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [showUserSuggestions, setShowUserSuggestions] = useState(false);
  const [suggestedUsers, setSuggestedUsers] = useState([]);
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);
  const [showTagSuggestions, setShowTagSuggestions] = useState(false);
  const [suggestedTags, setSuggestedTags] = useState([]);
  const [selectedTagIndex, setSelectedTagIndex] = useState(0);
  const [currentSelectedTags, setCurrentSelectedTags] = useState([]);
  const [currentSelectedUser, setCurrentSelectedUser] = useState(null);
  const [tagCreating, setTagCreating] = useState(false);
  const textareaRef = useRef(null);
  const tags = [
    "Монтаж",
    "Диктор",
    "ГЗГ",
    "Графика",
    "Хроника",
    "Стоки",
    "Контент",
    "Музыка",
  ];
  const colorsArray = [
    "#9D7BFF",
    "#EA5B6F",
    "#FF78B5",
    "#C64CBF",
    "#B69BF0",
    "#F49BAB",
    "#D23D9B",
    "#CA6DC1",
    "#6B97FD",
    "#5070FF",
    "#3386FF",
    "#FFBA5F",
    "#E98D35",
    "#FD895F",
    "#FAFA92",
    "#FEFFC1",
    "#FFCD67",
    "#AFC55E",
    "#3EDD95",
    "#88D669",
    "#87DDFF",
    "#2BC1DF",
    "#17B7AC",
    "#93DA97",
  ];
  const [currentTagText, setCurrentTagText] = useState("");
  const [currentTagColor, setCurrentTagColor] = useState("#F3A1F0");
  const [emojiPickerOpened, setEmojiPickerOpened] = useState(false);
  const [recordDuration, setRecordDuration] = useState(0);

  const [currentRecord, setCurrentRecord] = useState(null);
  const [currentRecordBlob, setCurrentRecordBlob] = useState(null);
  // Плашка записи: idle | recording | recorded
  const [voiceMode, setVoiceMode] = useState("idle");
  const voiceRecorderRef = useRef(null);
  const isMobile = useIsMobile();
  const emojiRef = useRef();

  useEffect(() => {
    if ("virtualKeyboard" in navigator) {
      const geometryChange = (event) => {
        const { height } = event.target.geometry;
        document.documentElement.style.setProperty(
          "--keyboard-height",
          `${height}px`
        );
      };
      navigator.virtualKeyboard.addEventListener(
        "geometrychange",
        geometryChange
      );

      return () => {
        navigator.virtualKeyboard.removeEventListener(
          "geometrychange",
          geometryChange
        );
      };
    }
  }, []);

  useEffect(() => {
    const handleStartCommenting = (e) => {
      const target = e.target;
      const isEditable =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;
      if (isEditable) return;
      console.log(e);
      if (!e.metaKey && e.code === "KeyC") {
        e.preventDefault();
        textareaRef.current?.focus();
        videoControls.pause();
      }
    };
    window.addEventListener("keydown", handleStartCommenting);
    return () => window.removeEventListener("keydown", handleStartCommenting);
  }, [videoControls]);

  useEffect(() => {
    if (newCommentEnd) {
      setTimeRange(newCommentEnd);
    }
    // let newTimeRange = {
    //   ...timeRange,
    //   end: newCommentEnd,
    // };
  }, [newCommentEnd]);

  useEffect(() => {
    if (currentEditedComment) {
      setComment(currentEditedComment.content);
      setCurrentSelectedTags(currentEditedComment.tags);
      if (
        currentEditedComment.mentions &&
        currentEditedComment.mentions.length
      ) {
        setCurrentSelectedUser(currentEditedComment.mentions[0]);
      }
    }
  }, [currentEditedComment]);

  useEffect(() => {
    updateTagsArray();
  }, []);

  // Update timestamps when video time changes
  useEffect(() => {
    if (!timeRange.end) {
      // If we only have one timestamp, update it
      setTimeRange((prev) => ({
        ...prev,
        start: currentTime || 0,
      }));
    }
    //  else {
    //   // If we have two timestamps and current time is before start time,
    //   // make both equal to current time
    //   if (currentTime < timeRange.start) {
    //     setTimeRange({
    //       start: currentTime || 0,
    //       end: currentTime || 0,
    //     });
    //   }
    // else {
    //   // Otherwise, update the second timestamp
    //   setTimeRange((prev) => ({
    //     ...prev,
    //     end: currentTime || 0,
    //   }));
    // }
    // }
  }, [currentTime]);

  // Handle video click when in location mode
  const handleVideoClick = (e) => {
    if (!isLocationMode) return;

    // Stop the event completely
    e.preventDefault();
    e.stopPropagation();
    // Get the video element from videoControls
    const videoElement = videoControls?.getVideoElement?.();

    if (!videoElement) {
      return;
    }

    // Get the video's bounding rectangle
    const rect = videoElement.getBoundingClientRect();

    // Calculate click position relative to the video element
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Convert to percentages for responsive positioning
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    onSetMarkerPoint({ x: xPercent, y: yPercent });
  };

  // Toggle location mode
  const handleLocationClick = () => {
    if (!isLocationMode) {
      setIsLocationMode(true);
      if (videoControls?.pause) {
        videoControls.pause();
      }
    } else {
      setIsLocationMode(false);
      onSetMarkerPoint(null);
    }
  };

  // Clean up
  useEffect(() => {
    return () => {
      setIsLocationMode(false);
      onSetMarkerPoint(null);
    };
  }, []);

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return "00:00";
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const handleAddEndTime = () => {
    const currentVideoTime = videoRef?.current?.currentTime || currentTime || 0;
    setTimeRange((prev) => ({
      ...prev,
      end: currentVideoTime,
    }));
  };

  const handleRemoveEndTime = () => {
    setNewMarkerInfo({
      ...newMarkerInfo,
      positionEnd: null,
      timecodeEnd: null,
    });
    setTimeRange((prev) => ({
      start: currentTime || 0,
      end: null,
    }));
  };

  const handleCommentChange = (e) => {
    const value = e.target.value;
    setComment(value);

    // Check for @ symbol and show user suggestions
    const lastAtIndex = value.lastIndexOf("@");
    if (lastAtIndex !== -1) {
      const searchText = value.slice(lastAtIndex + 1);
      const filteredUsers = projectUsers.filter((user) =>
        user.email.toLowerCase().includes(searchText.toLowerCase())
      );

      if (filteredUsers.length > 0) {
        setSuggestedUsers(filteredUsers);
        setShowUserSuggestions(true);
        setSelectedUserIndex(0);
      } else {
        setShowUserSuggestions(false);
      }
    } else {
      setShowUserSuggestions(false);
    }

    // Check for # symbol and show tag suggestions
    // Find the last # that starts a word
    const hashMatch = value.match(/(^|\s)#([\wа-яА-Яё]*)$/);
    if (hashMatch) {
      const searchText = hashMatch[2];
      const filteredTags = tags.filter((tag) =>
        tag.toLowerCase().includes(searchText.toLowerCase())
      );
      setSuggestedTags(filteredTags);
      setShowTagSuggestions(true);
      setSelectedTagIndex(0);
      // Store the current tag text for tag-create-block
      setCurrentTagText(searchText);
    } else {
      setShowTagSuggestions(false);
      setCurrentTagText("");
    }
  };

  const setTagAndSubmit = () => {
    const existingTag = tagsArray.find(
      (tag) => tag.name === currentTagText.toLowerCase()
    );
    if (existingTag) {
      handleTagSelect(existingTag);
      const lastHashIndex = comment.lastIndexOf("#");
      const newComment = comment.slice(0, lastHashIndex);
      handleSubmit(existingTag, newComment);
    } else {
      setTagCreating(true);
      const randomColor =
        colorsArray[Math.floor(Math.random() * colorsArray.length)];
      const tagInfo = {
        name: currentTagText.toLowerCase(),
        color: randomColor,
        organizationId: sharedOrgId || currentOrganization.id,
      };
      dispatch(createTag(tagInfo)).then((res) => {
        if (!res.error) {
          toast.success("Тэг успешно добавлен!");
          setTagCreating(false);
          const lastHashIndex = comment.lastIndexOf("#");
          const newComment = comment.slice(0, lastHashIndex);
          setComment(newComment);
          updateTagsArray();
          setCurrentSelectedTags([...currentSelectedTags, res.payload]);
          setShowTagSuggestions(false);
          handleSubmit(res.payload, newComment);
        } else {
          toast.error("Ошибка при добавлении тэга");
          setTagCreating(false);
        }
      });
    }
  };

  const handleKeyDown = (e) => {
    if (showUserSuggestions) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedUserIndex((prev) => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedUserIndex((prev) =>
          prev < suggestedUsers.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleUserSelect(suggestedUsers[selectedUserIndex]);
      } else if (e.key === "Escape") {
        setShowUserSuggestions(false);
      }
    } else if (showTagSuggestions) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedTagIndex((prev) =>
          prev < suggestedTags.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedTagIndex((prev) => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        setTagAndSubmit();
        //handleTagSelect(suggestedTags[selectedTagIndex]);
      } else if (e.key === "Escape") {
        setShowTagSuggestions(false);
      } else if (e.key === " ") {
        // Hide dropdown if space is pressed and no tag is selected/created
        setShowTagSuggestions(false);
      }
    } else if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleUserSelect = (user) => {
    const lastAtIndex = comment.lastIndexOf("@");
    const newComment = comment.slice(0, lastAtIndex);
    setComment(newComment);
    setCurrentSelectedUser(user);
    setShowUserSuggestions(false);
  };

  const handleTagSelect = (tag) => {
    const lastHashIndex = comment.lastIndexOf("#");
    let newComment = comment;
    if (lastHashIndex > -1) {
      newComment = comment.slice(0, lastHashIndex);
    }

    setComment(newComment);
    setCurrentSelectedTags([...currentSelectedTags, tag]);
    setShowTagSuggestions(false);
  };

  const checkTagsBeforeSubmitting = async () => {
    // Find all tags in the comment text
    // Tag pattern: # followed by word characters (including Cyrillic)
    const tagRegex = /#([\wa-zA-Zа-яА-Яё]+)/g;
    const tags = [];
    let editableComment = comment;
    let newSelectedTags = [...currentSelectedTags];
    let match;
    while ((match = tagRegex.exec(editableComment)) !== null) {
      editableComment = editableComment.split(match[0]).join("");
      tags.push(match[1]);
      match = tagRegex.exec(editableComment);
    }

    for (let i = 0; i < tags.length; i++) {
      const tagName = tags[i];
      const existingTag = tagsArray.find(
        (tagItem) => tagItem.name === tagName.toLowerCase()
      );
      if (!!existingTag) {
        newSelectedTags = [...newSelectedTags, existingTag];
      } else {
        const randomColor =
          colorsArray[Math.floor(Math.random() * colorsArray.length)];
        const tagInfo = {
          name: tagName.toLowerCase(),
          color: randomColor,
          organizationId: sharedOrgId || currentOrganization.id,
        };
        const res = await dispatch(createTag(tagInfo));
        newSelectedTags = [...newSelectedTags, res.payload];
      }
    }

    // Remove all tags from the comment
    let cleanedComment = comment;
    tags.forEach((tagName) => {
      const tagPattern = new RegExp(`#${tagName}\\s*`, "g");
      cleanedComment = cleanedComment.replace(tagPattern, "");
    });

    // Clean up any extra spaces that might be left
    cleanedComment = cleanedComment.replace(/\s+/g, " ").trim();

    const timecode = timeRange.end
      ? `${timeRange.start} - ${timeRange.end}`
      : timeRange.start;

    let commentData = {
      content: cleanedComment,
      authorId: user.userId,
      timecode,
    };

    commentData.tagIds = newSelectedTags.map((tag) => tag.id);

    if (newSelectedTags.length > 0) {
      const lastUsedTags =
        JSON.parse(localStorage.getItem("lastUsedTagIds")) || [];

      let newLastUsedTags = [...lastUsedTags];
      const existingTagIndex = newLastUsedTags.findIndex(
        (tagId) => tagId === newSelectedTags[0].id
      );

      if (existingTagIndex > -1) {
        newLastUsedTags.splice(existingTagIndex, 1);
      }
      newLastUsedTags = [newSelectedTags[0].id, ...newLastUsedTags];
      localStorage.setItem("lastUsedTagIds", JSON.stringify(newLastUsedTags));
    }

    if (currentSelectedUser) {
      commentData.mentions = [currentSelectedUser.userId];
    } else {
      commentData.mentions = [];
    }

    onSubmitComment(commentData);
    setNewMarkerInfo(null);
    setComment("");
    setCurrentSelectedTags([]);
    setCurrentSelectedUser(null);
    updateTagsArray();
    return;
  };

  const handleSubmit = async (chosenTag = null, readyCommentText = null) => {
    let commentText = readyCommentText || comment;
    if (
      !commentText.trim() &&
      (!currentSelectedTags || !currentSelectedTags.length) &&
      !currentRecord
    )
      return;

    if (commentText.indexOf("#") > -1) {
      checkTagsBeforeSubmitting();
      return;
    }

    let attachments = [];

    if (currentRecord) {
      const mediaData = {
        type: "VOICE",
        contentType: "audio/mp3",
        contextKind: "VIDEO",
        contextId: +versionId,
      };
      const presignRes = await dispatch(
        createMediaPresign({
          mediaData,
        })
      );
      if (!presignRes.error) {
        const fetchRes = await fetch(presignRes.payload.uploadUrl, {
          method: "PUT",
          headers: presignRes.payload.requiredHeaders,
          body: currentRecordBlob,
        });
        if (!fetchRes.error) {
          const mediaData = {
            durationMs: Math.round((recordDuration || 0) * 1000),
          };
          const completeRes = await dispatch(
            completeMediaUpload({
              mediaId: presignRes.payload.mediaId,
              mediaData,
            })
          );
          if (!completeRes.error) {
            attachments = [
              ...attachments,
              {
                mediaId: presignRes.payload.mediaId,
                sortOrder: 0,
              },
            ];
          }
        }
      }
    }

    const timecode = timeRange.end
      ? `${timeRange.start} - ${timeRange.end}`
      : timeRange.start;

    let commentData = {
      content: commentText,
      authorId: user.userId,
      timecode,
      attachments,
    };

    if (chosenTag && chosenTag.id) {
      commentData.tagIds = [chosenTag.id];
      const lastHashIndex = commentText.lastIndexOf("#");
      const newComment = commentText.slice(0, lastHashIndex);
      commentData.content = newComment;

      const lastUsedTags =
        JSON.parse(localStorage.getItem("lastUsedTagIds")) || [];

      let newLastUsedTags = [...lastUsedTags];
      const existingTagIndex = newLastUsedTags.findIndex(
        (tagId) => tagId === chosenTag.id
      );

      if (existingTagIndex > -1) {
        newLastUsedTags.splice(existingTagIndex, 1);
      }
      newLastUsedTags = [chosenTag.id, ...newLastUsedTags];
      localStorage.setItem("lastUsedTagIds", JSON.stringify(newLastUsedTags));
    } else if (currentSelectedTags.length) {
      commentData.tagIds = currentSelectedTags.map((tag) => tag.id);

      const lastUsedTags =
        JSON.parse(localStorage.getItem("lastUsedTagIds")) || [];

      let newLastUsedTags = [...lastUsedTags];
      const existingTagIndex = newLastUsedTags.findIndex(
        (tagId) => tagId === currentSelectedTags[0].id
      );

      if (existingTagIndex > -1) {
        newLastUsedTags.splice(existingTagIndex, 1);
      }
      newLastUsedTags = [currentSelectedTags[0].id, ...newLastUsedTags];
      localStorage.setItem("lastUsedTagIds", JSON.stringify(newLastUsedTags));
    }

    if (currentSelectedUser) {
      commentData.mentions = [
        currentSelectedUser.userId || currentSelectedUser.id,
      ];
    } else {
      commentData.mentions = [];
    }

    let isEdit = false;

    if (currentEditedComment) {
      isEdit = true;
      commentData = {
        ...currentEditedComment,
        ...commentData,
      };
    }

    onSubmitComment(commentData, isEdit);
    setNewMarkerInfo(null);
    setComment("");
    if (currentRecord && currentRecord.startsWith("blob:")) {
      URL.revokeObjectURL(currentRecord);
    }
    setCurrentRecord(null);
    setCurrentRecordBlob(null);
    setCurrentSelectedTags([]);
    setCurrentSelectedUser(null);
    updateTagsArray();
    resetCurrentEditedComment();
    return;
  };

  const onPressIfShared = (e) => {
    e.target.blur();
    onShowSharedNeedLogin();
  };

  const handleCreateTag = () => {
    setTagCreating(true);
    const randomColor =
      colorsArray[Math.floor(Math.random() * colorsArray.length)];
    const tagInfo = {
      name: currentTagText.toLowerCase(),
      color: randomColor,
      organizationId: sharedOrgId || currentOrganization.id,
    };
    dispatch(createTag(tagInfo)).then((res) => {
      if (!res.error) {
        toast.success("Тэг успешно добавлен!");
        setTagCreating(false);
        const lastHashIndex = comment.lastIndexOf("#");
        const newComment = comment.slice(0, lastHashIndex);
        setComment(newComment);
        updateTagsArray();
        setCurrentSelectedTags([...currentSelectedTags, res.payload]);
        setShowTagSuggestions(false);
      } else {
        toast.error("Ошибка при добавлении тэга");
        setTagCreating(false);
      }
    });
  };

  const handleMicButtonClick = () => {
    if (isShared) {
      onPressIfShared();
      return;
    }
    if (voiceMode === "recording") {
      voiceRecorderRef.current?.stopRecording();
      return;
    }
    if (voiceMode === "recorded") {
      voiceRecorderRef.current?.restartRecording();
      return;
    }
    voiceRecorderRef.current?.startRecording();
  };

  return (
    <div className={isMobile ? "write-comment-mobile" : "write-comment"}>
      {currentEditedComment && (
        <div
          style={{
            width: "100%",
            // height: 194,
            backgroundColor: "#181c24",
            bottom: 0,
            zIndex: 1,
            borderRadius: 16,
            paddingTop: 10,
            paddingLeft: 15,
            paddingRight: 10,
            paddingBottom: 10,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            // border: "1px solid grey",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 500, color: "white" }}>
              Редактирование
            </span>
            <span
              className="edited-comment-text"
              style={{ fontSize: 14, fontWeight: 500, color: "#717b8e" }}
            >
              {currentEditedComment.content}
            </span>
          </div>
          <button
            style={{
              // position: "absolute",
              // top: "32px",
              // right: "32px",
              width: "24px",
              height: "24px",
              background: "none",
              border: "none",
              color: "#c1c4cb",
              fontSize: "24px",
              cursor: "pointer",
              // zIndex: 1,
            }}
            onClick={() => {
              resetCurrentEditedComment();
              setComment("");
            }}
          >
            &times;
          </button>
        </div>
      )}
      <div className="write-comment-main-content">
        <div
          className={`timestamp-container ${timeRange.end ? "has-range" : ""}`}
        >
          <button className="timestamp">{formatTime(timeRange.start)}</button>
          {(!timeRange.end && (
            <button
              className="add-timestamp"
              onClick={isShared ? onPressIfShared : handleAddEndTime}
            >
              +
            </button>
          )) ||
            null}
          {(timeRange.end && (
            <>
              {/* <div className="timestamp-line" /> */}
              <button className="timestamp second-timestamp">
                {formatTime(timeRange.end)}
                <button
                  className="remove-timestamp"
                  onClick={handleRemoveEndTime}
                />
              </button>
            </>
          )) ||
            null}
          <button
            className="add-timestamp"
            style={{ fontSize: 15 }}
            onClick={() => setShowTagSuggestions((v) => !v)}
          >
            #
          </button>
          {(currentSelectedTags && currentSelectedTags.length && (
            <div
              className="new-tags-row"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
                overflowX: "scroll",
                flex: 1,
                // width: "100%",
              }}
            >
              {currentSelectedTags.map((tagValue) => (
                <div style={{ position: "relative" }}>
                  <TagComponent
                    tagsDefaultColors={tagsDefaultColors}
                    key={tagValue.id}
                    tag={tagValue}
                    onClick={() => {
                      const newCurrentSelectedTags = currentSelectedTags.filter(
                        (tagVal) => tagVal.id !== tagValue.id
                      );
                      setCurrentSelectedTags(newCurrentSelectedTags);
                    }}
                  />
                  <div
                    onClick={() => {
                      const newCurrentSelectedTags = currentSelectedTags.filter(
                        (tagVal) => tagVal.id !== tagValue.id
                      );
                      setCurrentSelectedTags(newCurrentSelectedTags);
                    }}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: -5,
                      width: 15,
                      height: 15,
                      border: "0px solid white",
                      backgroundColor: "rgba(31, 36, 46, 1)",
                      borderRadius: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      boxSizing: "border-box",
                      paddingBottom: 3,
                      fontSize: 10,
                      cursor: "pointer",
                    }}
                  >
                    x
                  </div>
                </div>
              ))}
            </div>
          )) ||
            // (
            //   <div>
            //     <TagComponent
            //       tagsDefaultColors={tagsDefaultColors}
            //       key={currentSelectedTags[0].id}
            //       tag={currentSelectedTags[0]}
            //       onClick={() => setCurrentSelectedTags([])}
            //     />
            //     <div
            //       onClick={() => setCurrentSelectedTags([])}
            //       style={{
            //         position: "absolute",
            //         top: -4,
            //         right: -5,
            //         width: 15,
            //         height: 15,
            //         border: "0px solid white",
            //         backgroundColor: "rgba(31, 36, 46, 1)",
            //         borderRadius: 10,
            //         display: "flex",
            //         alignItems: "center",
            //         justifyContent: "center",
            //         color: "white",
            //         boxSizing: "border-box",
            //         paddingBottom: 3,
            //         fontSize: 10,
            //         cursor: "pointer",
            //       }}
            //     >
            //       x
            //     </div>
            //   </div>
            // )
            null}
          {(currentSelectedUser && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setCurrentSelectedUser(null)}
            >
              <Avatar name={currentSelectedUser.email} size={24} />
            </div>
          )) ||
            null}
        </div>

        <div className="comment-input-container">
          <div
            style={{
              display: voiceMode === "idle" ? "none" : "block",
              marginBottom: voiceMode === "recording" ? 0 : 8,
            }}
          >
            <VoiceRecorder
              ref={voiceRecorderRef}
              recordUrl={currentRecord}
              isShared={isShared}
              onModeChange={setVoiceMode}
              onRecorded={(blob, blobUrl) => {
                setCurrentRecord(blobUrl);
                setCurrentRecordBlob(blob);
              }}
              onRecordCleared={() => {
                setCurrentRecord(null);
                setCurrentRecordBlob(null);
                setRecordDuration(0);
              }}
              onLimitReached={() =>
                toast("Достигнута максимальная длительность записи — 5 минут")
              }
              onDurationChange={setRecordDuration}
            />
          </div>

          {voiceMode !== "recording" && (
            <textarea
              ref={textareaRef}
              className="comment-input"
              placeholder={t("comments.write")}
              value={comment}
              onChange={handleCommentChange}
              onKeyDown={handleKeyDown}
              rows={1}
              onFocus={isShared ? onPressIfShared : () => {}}
            />
          )}
          {showUserSuggestions && (
            <UserSuggestionDropdown
              users={suggestedUsers}
              searchQuery={comment.slice(comment.lastIndexOf("@") + 1)}
              onSelect={handleUserSelect}
              selectedIndex={selectedUserIndex}
            />
          )}
          {showTagSuggestions && (
            <TagsSuggestionDropdown
              onClose={() => setShowTagSuggestions(false)}
              tags={suggestedTags}
              searchQuery={currentTagText}
              onSelect={handleTagSelect}
              selectedIndex={selectedTagIndex}
              handleCreateTag={handleCreateTag}
              tagCreating={tagCreating}
              currentTagColor={currentTagColor}
              tagsArray={tagsArray}
              colorsArray={colorsArray}
              setCurrentTagColor={setCurrentTagColor}
              tagsDefaultColors={tagsDefaultColors}
              updateTagsArray={updateTagsArray}
            />
          )}
        </div>

        <div className="actions-container">
          <div className="action-buttons">
            <button
              className={`action-button ${isLocationMode ? "active" : ""}`}
              onClick={handleLocationClick}
            >
              <img src={locationIcon} alt="Location" />
            </button>
            <button className="action-button">
              <img src={screenshotIcon} alt="Screenshot" />
            </button>
            <button className="action-button">
              <img src={drawingIcon} alt="Drawing" />
            </button>
          </div>

          <div className="right-buttons">
            <ClickAwayListener
              onClickAway={(e) => {
                if (!emojiPickerOpened) return;
                const isInside =
                  (e.target.className &&
                    e.target.className.includes("epr-btn")) ||
                  e.target.className.includes("epr-emoji");
                if (!isInside) {
                  setEmojiPickerOpened(false);
                }
              }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={
                  isShared
                    ? onPressIfShared
                    : () => setEmojiPickerOpened(!emojiPickerOpened)
                }
              >
                😃
              </div>
            </ClickAwayListener>
            <EmojiPicker
              searchDisabled={true}
              onEmojiClick={(emoji) => setComment(comment + "" + emoji.emoji)}
              categories={[]}
              previewConfig={{
                showPreview: false,
              }}
              style={{
                position: "absolute",
                bottom: 120,
                zIndex: 10000,
                width: "90%",
                scrollbarWidth: "none" /* Firefox */,
                msOverflowStyle: "none" /* IE and Edge */,
                "&::-webkit-scrollbar": {
                  /* Chrome, Safari and Opera */ display: "none",
                },
              }}
              theme="dark"
              ref={emojiRef}
              open={emojiPickerOpened}
            />
            <button
              onClick={handleMicButtonClick}
              title={
                voiceMode === "recording"
                  ? "Остановить запись"
                  : voiceMode === "recorded"
                    ? "Записать заново"
                    : "Записать голосовое"
              }
              className={`action-button ${
                voiceMode === "recording" ? "recording" : ""
              }`}
            >
              {voiceMode === "recording" ? (
                <StopRecordIcon
                  style={{
                    stroke: "#9a6aff",
                    color: "#9a6aff",
                    transform: "scale(0.8)",
                  }}
                />
              ) : (
                <MicIcon
                  style={{
                    stroke: "#9a6aff",
                    color: "#9a6aff",
                    transform: "scale(0.8)",
                  }}
                />
              )}
            </button>
            <button
              className="send-button"
              onClick={handleSubmit}
              disabled={
                !comment.trim() &&
                !currentSelectedTags.length &&
                !isSendingComment &&
                !currentRecord
              }
            >
              {isSendingComment ? (
                <OrbitProgress style={{ fontSize: 4 }} color="white" />
              ) : currentEditedComment ? (
                "Сохранить"
              ) : (
                t("comments.send")
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WriteComment;
